export default "__VITE_ASSET__0393370c__"